import { render } from "./About.vue?vue&type=template&id=29426ced&scoped=true"
const script = {}

import "./About.vue?vue&type=style&index=0&id=29426ced&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-29426ced"

export default script